import Pusher from "pusher-js";

// Une seule connexion temps réel par onglet, partagée par tout ce qui en a
// besoin : le canal personnel (MessengerNotificationsContext), le fil ouvert
// dans la messagerie et celui de la fenêtre flottante. Chacun ouvrait la
// sienne : un onglet pouvait tenir deux connexions pour le même compte, et
// changer de discussion dans la fenêtre refaisait toute la poignée de main.
//
// Le compteur dit combien de composants s'en servent. Au dernier départ, la
// connexion reste ouverte quelques secondes : changer de discussion ou de
// page rend puis reprend la connexion dans la foulée, et la couper entre les
// deux ferait sortir puis rentrer l'utilisateur de la liste des présents.
const CLOSE_DELAY_MS = 10000;

let client = null;
let users = 0;
let closeTimer = null;

export function acquirePusher() {
    if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
    }
    if (!client) {
        client = new Pusher(process.env.PUSHER_APP_KEY, {
            cluster: process.env.PUSHER_APP_CLUSTER,
            authEndpoint: "/api/pusherauth",
        });
    }
    users += 1;
    return client;
}

export function releasePusher() {
    users = Math.max(0, users - 1);
    if (users > 0 || !client || closeTimer) return;
    closeTimer = setTimeout(() => {
        closeTimer = null;
        if (users > 0 || !client) return;
        client.disconnect();
        client = null;
    }, CLOSE_DELAY_MS);
}
